import * as React from "react"

// styles
import "../styles/css/styles.css"


// Institucional 
const objs = {
    institucional: [
        {
            label: 'Quem Somos',
            link: '/page/quem-somos'
        },
        {
            label: 'Patrocínios',
            link: '/page/patrocinios/'
        },
        {
            label: 'Representantes',
            link: '/page/representantes'
        },
        {
            label: 'Contato Wega',
            link: '/contato'
        },
        {
            label: 'Unidades',
            link: '/page/unidades-wega'
        },
        {
            label: 'Trabalhe Conosco',
            link: '/page/trabalhe-conosco/'
        }        
    ],
    dicas: [
        {
            label: 'Você Sabia?',
            link: '/category/voce-sabia/'
        },
        {
            label: 'Boletins Técnicos',
            link: '/category/boletins-tecnicos/'
        },
        {
            label: 'Vídeos',
            link: '/category/videos/'
        },
        {
            label: 'Notícias Wega',
            link: '/category/noticias-wega/'
        }
    ]
}

const MenuInstitucional = (props) => {

    if(props.type == 'institucional'){
        return(
            <div className="footer-item">
                <ul className="footer-item-container">
                    {
                        objs.institucional.map(item => (
                            <li className="footer-list-item"><a href={item.link} className="item">{item.label}</a></li>
                        ))                            
                    }
                </ul>
            </div>
        )
    }else if(props.type == 'dicas') {
        return(
            <div className="footer-item">
                <ul className="footer-item-container">
                    {
                        objs.dicas.map(item => (
                            <li className="footer-list-item"><a href={item.link} className="item">{item.label}</a></li>
                        ))                            
                    }
                </ul>
            </div>
        )
    }
}

export default MenuInstitucional